import src from "IMAGE";
export default { src, width: 314, height: 226, blurWidth: 0, blurHeight: 0};
